import { render, staticRenderFns } from "./tableCommonSelector.vue?vue&type=template&id=15023eb3&scoped=true"
import script from "./tableCommonSelector.vue?vue&type=script&lang=js"
export * from "./tableCommonSelector.vue?vue&type=script&lang=js"
import style0 from "./tableCommonSelector.vue?vue&type=style&index=0&id=15023eb3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15023eb3",
  null
  
)

export default component.exports